import { Injectable, Type } from '@angular/core';
import { DialogBox } from '../components/dialog-box/dialog-box';
import { IDialogConfig } from '../model/DialogConfig';

@Injectable({
  providedIn: 'root',
})
export class DialogService {

  private dialogBox!: DialogBox;
  currentConfig!: IDialogConfig<any>;

  register(ref: DialogBox) {
    this.dialogBox = ref;
  }

  open<TComponent, TData = unknown, TResult = unknown>(
    component: Type<TComponent>,
    config: IDialogConfig<TData> = {}
  ): Promise<TResult | undefined> {
    if (!this.dialogBox) {
      throw new Error('DialogBox is not registered. Add <app-dialog-box> to your root template.');
    }
    this.currentConfig = config;
    console.log('Opening dialog with config:', config);
    return this.dialogBox.open<TComponent, TData, TResult>(component, config);
  }

  close(result?: unknown) {
    this.dialogBox?.close(result);
  }
}
